import 'leaflet-draw';
import { geoJSON, LatLngBounds, LatLngBoundsLiteral } from 'leaflet';
import { toJS } from 'mobx';
import { observer } from 'mobx-react-lite';
import { PropsWithChildren, ReactElement, useEffect } from 'react';
import { usePrevious } from '../../../../design/hooks/usePrevious';
import { useMap } from '../../../../useMap';
import { ISegmentation } from '../annotations.interface';

const FRAME_PADDING: number = 5;
const FRAME_PADDING_POINT: number = 10;

interface IProps extends PropsWithChildren {
  invalidSegmentation?: ISegmentation;
}

export const SegmentationFocusControl = observer((props: IProps): ReactElement => {
  const previousInvalidSegmentation = usePrevious(props.invalidSegmentation);
  const map = useMap();

  useEffect(() => {
    if (props.invalidSegmentation !== undefined && props.invalidSegmentation.feature.id !== previousInvalidSegmentation?.feature.id) {
      centerOnSegmentation(props.invalidSegmentation);
    }
  }, [props.invalidSegmentation]);

  const getBounds = (segmentation: ISegmentation): LatLngBounds => {
    const bounds = geoJSON(segmentation.feature.geometry).getBounds();
    const framePadding =
      segmentation.feature.geometry.type === 'Point' || segmentation.feature.geometry.type === 'LineString' ? FRAME_PADDING_POINT : FRAME_PADDING;

    const extended: LatLngBoundsLiteral = [
      [bounds.getSouth() - framePadding, bounds.getWest() - framePadding],
      [bounds.getNorth() + framePadding, bounds.getEast() + framePadding],
    ];

    return new LatLngBounds(extended);
  };

  const centerOnSegmentation = (segmentation: ISegmentation): void => {
    if (!segmentation) {
      return;
    }
    const bounds = getBounds(toJS(segmentation));
    map.panTo(bounds.getCenter(), { animate: false });
  };

  return <>{props.children}</>;
});
